
<div class="container" [ngClass]="{'general-disabled': deployment?.isMigrationActive}">
  <div class="row">
    <div class="col">
      <p class="text-center">Import the completed Partner Installation spreadsheet</p>
    </div>
  </div>
  <div class="row">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" [uploadFileTo]="'/api/deploymentworkflow/import-partner-install?projectId=' + projectId + '&amp;deploymentId=' + deploymentId" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Import Partner Installation Form'"><span class="oi oi-cloud-upload"></span> Upload Partner Installation Form</a></div>
    <div class="col"> </div>
  </div>
</div>